import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AuthenticatedFooter from './footers/AuthenticatedFooter'
import UnauthenticatedFooter from './footers/UnauthenticatedFooter'

class Footer extends Component {
  render() {
    const { user, dispatch } = this.props
    return (
      <footer
        className={
          user.isAuthenticated
            ? 'auth'
            : 'unauth footer navbar navbar-bottom navbar-inverse'
        }
      >
        {user.isAuthenticated ? (
          <AuthenticatedFooter dispatch={dispatch} />
        ) : (
          <UnauthenticatedFooter />
        )}
      </footer>
    )
  }
}

Footer.propTypes = {
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
}

export const mapStateToProps = state => ({
  user: state.user
})

export default connect(mapStateToProps)(Footer)
export { Footer as FooterDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/Footer.js